"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useComponentColumns = exports.useColumns = void 0;
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const table_field_cells_1 = require("../../../components/table-field/table-field-cells");
const table_cells_1 = require("../../../composite/table/table-cells");
const ess_api_1 = require("../ess-api");
/**
 * fixme: add record and components, type
 */
function useColumns() {
    const intl = react_intl_1.useIntl();
    return [
        {
            datakey: 'referenceNumber',
            name: intl.formatMessage({
                id: 'ESS_DOCUMENTS_COLUMN_REFERENCE_NUMBER',
                defaultMessage: 'Číslo jednací',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'name',
            name: intl.formatMessage({
                id: 'ESS_DOCUMENTS_COLUMN_NAME',
                defaultMessage: 'Název',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'description',
            name: intl.formatMessage({
                id: 'ESS_DOCUMENTS_COLUMN_DESCRIPTION',
                defaultMessage: 'Popis',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'classificationCode',
            name: intl.formatMessage({
                id: 'ESS_DOCUMENTS_COLUMN_CLASSIFICATION_CODE',
                defaultMessage: 'Spisový znak',
            }),
            width: 120,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'barCode',
            name: intl.formatMessage({
                id: 'ESS_DOCUMENTS_COLUMN_BARCODE',
                defaultMessage: 'Čárový kód',
            }),
            width: 120,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'essId',
            name: intl.formatMessage({
                id: 'ESS_DOCUMENTS_COLUMN_ESSID',
                defaultMessage: 'ID',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            valueMapper: ({ value }) => value != null ? `${value.source}:${value.id}` : '',
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'record.essId',
            filterkey: 'recordEssId',
            sortkey: 'recordEssId',
            name: intl.formatMessage({
                id: 'ESS_DOCUMENTS_COLUMN_ESSID',
                defaultMessage: 'ID Spisu',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            valueMapper: ({ value }) => value != null ? `${value.source}:${value.id}` : '',
            sortable: true,
            filterable: true,
        },
    ];
}
exports.useColumns = useColumns;
function useComponentColumns() {
    const intl = react_intl_1.useIntl();
    const TypeCell = table_field_cells_1.TableFieldCells.useSelectCellFactory(ess_api_1.useComponentTypes);
    return react_1.useMemo(() => [
        {
            datakey: 'file',
            name: intl.formatMessage({
                id: 'ESS_COMPONENTS_COLUMN_FILE',
                defaultMessage: 'Soubor',
            }),
            width: 200,
            CellComponent: table_field_cells_1.TableFieldCells.FileCell,
        },
        {
            datakey: 'syncTime',
            name: intl.formatMessage({
                id: 'ESS_COMPONENTS_COLUMN_SYNC_TIME',
                defaultMessage: 'Čas synchronizace',
            }),
            width: 200,
            CellComponent: table_field_cells_1.TableFieldCells.DateTimeCell,
        },
        {
            datakey: 'type',
            name: intl.formatMessage({
                id: 'ESS_COMPONENTS_COLUMN_TYPE',
                defaultMessage: 'Typ',
            }),
            width: 150,
            CellComponent: TypeCell,
        },
    ], [TypeCell, intl]);
}
exports.useComponentColumns = useComponentColumns;
//# sourceMappingURL=documents-columns.js.map